 const messages = {
    THA: {//泰文
      model5012X1L: "7100 4T 10W50 12X1L",
      model5W40:"Scooter Power LE 4T 5W40",
      model4012X1L: "7100 4T 10W40 12X1L",
      model20X1L: "H-Tech 100 4T 10W40 20X1L",
      model710010W40: "7100 4T 10W40 12X1L",
      model710010W50: "7100 4T 10W50 12X1L",
      model710015W50: "7100 4T 15W50 12X1L",
      modelHTECH: "H-Tech 100 4T 10W40 20X1L",
      modelSCOOTER: "SCOOTER POWER LE 4T5W40 12X1L",
      linkmodel710010W40: "16705?product=MOTUL+7100+10W-40+4T+VL&sourceLocale=en-SG&id=16705",
      linkmodel710010W50: "16706?product=MOTUL+7100+4T+10W50&sourceLocale=en-SG&id=16706",
      linkmodel710015W50: "16709?product=MOTUL+7100+4T+15W50&sourceLocale=en-SG&id=16709",
      linkmodelHTECH: "37302?product=H-TECH%2B100%2B4T%2B10W30%2B20X1L&sourceLocale=en-SG",
      linkmodelSCOOTER:"58150?product=MOTUL+SCOOTER+POWER+LE+4T+5W-40&sourceLocale=en-SG&id=58150",
      pageNub:"ข้อที่",
      page:"หน้า",
        page1: {
          proName: 'รหัสยืนยัน',
          ProCodeName: 'หมายเลขซีเรียล:',
          btnText:'ไม่พบการคัดลอก',
          moreText:'ปัดขึ้นเพื่อดูข้อมูลเพิ่มเติม',
        },
        page2 :{
          topText:'ข้อมูลผลิตภัณฑ์',
          btnText:'ข้อมูลเพิ่มเติม',
          moreText:'ปัดขึ้นเพื่อดูข้อมูลเพิ่มเติม',
          model5012X1L: "รถจักรยานยนต์สมรรถนะสูง รถจักรยานยนต์สปอร์ต จักรยานเสือหมอบและจักรยานเสือหมอบ จักรยานวิบาก จักรยานเอนดูโร จักรยานทดลอง...ติดตั้งเครื่องยนต์ 4 จังหวะ มีเกียร์แบบบูรณาการหรือไม่ก็ได้ คลัตช์เปียกหรือแห้ง เครื่องยนต์ที่เป็นไปตามข้อบังคับการปล่อยไอเสีย Euro 2 หรือ Euro 3 ติดตั้งระบบบำบัดก๊าซไอเสีย: ตัวเร่งปฏิกิริยา การฉีดอากาศเข้าท่อไอเสีย...แนะนำสำหรับเครื่องยนต์ DUCATI, KTM, BMW เฉพาะที่ต้องใช้เกรดน้ำมันที่มีความหนืด SAE 10W-50",
          model5W40: "น้ำมันหล่อลื่นเครื่องยนต์สี่จังหวะสังเคราะห์เต็มตัว น้ำมันหล่อลื่นสมรรถนะสูงปล่อยมลพิษต่ำ ออกแบบมาสำหรับเครื่องยนต์สกู๊ตเตอร์สี่จังหวะกำลังสูงที่ต้องการมาตรฐาน JASO MB ควบคุมการสะสมตัวของคาร์บอนในลูกสูบ การสึกหรอและการกัดกร่อนของแบริ่ง ฯลฯ ได้อย่างมีประสิทธิภาพ เหมาะสำหรับสภาพถนนทุกประเภท ถนนทั่วไป ถนนในเมือง และทางหลวง ฯลฯ หมายเหตุ: ไม่เหมาะกับเครื่องยนต์รถจักรยานยนต์ 4 จังหวะที่ต้องการ JASO MA2/MA1",
          model4012X1L: "100% Synthetic มาพร้อมกับเทคโนโลยี Ester สำหรับจักรยานยนต์ 4 จังหวะ สมรรถนะสูง ทั้งแบบสปอร์ตและแบบออฟโรด เหมาะกับระบบเกียร์ทั้งแบบคลัทช์เปียกและแห้ง เข้ากันได้กับเครื่องยนต์ มาตรฐาน Euro 2 หรือ Euro 3 ที่ติดตั้งระบบฟอกไอเสีย แนะนำสำหรับรถจักรยานยนต์ SUZUKI, YAMAHA,KAWASAKI ที่ผู้ผลิตแนะนำน้ำมันเบอร์ความหนืด SAE 10W-40",
          model20X1L: "น้ำมันหล่อลื่นสังเคราะห์แท้ 100% สำหรับเครื่องยนต์รถจักรยานยนต์ 4 จังหวะ ที่ต้องการน้ำมันเบอร์ความหนืด 10W40 เหมาะกับรถจักรยานยนต์ทั้งทางเรียบ และทางวิบาก รวมถึง รถ Scooters และ รถ Mopeds",
      },
      page3:{
        text1:"เครื่องมือที่เป็นประโยชน์",
        text2:"น้ำมันที่แนะนำ",
        text3:"ใช้หมายเลข VIN เพื่อค้นหาผลิตภัณฑ์ที่ดีที่สุดสำหรับรถยนต์ของคุณอย่างรวดเร็ว",
        text4:"ข้อมูลผลิตภัณฑ์"
      },
      page4:{
        topText:'ติดต่อเรา',
        middleText:' ให้เราช่วยคุณอย่างไรบ้าง ?',
        emailAct:'ติดต่อเรา'
     },
     verification: {
       titleText: 'ผลการตรวจสอบความแท้',
       infoText: 'ขอบคุณที่เลือกสินค้าของแท้จาก Motul.',
       productText: 'ชื่อผลิตภัณฑ์:',
       batchText: 'หมายเลขล็อต: 1089466',
       btnText: 'ดูรายละเอียดสินค้า',
      }
    },
    EN: {//英语
        model5012X1L: "7100 4T 10W50 12X1L",
        model5W40:"Scooter Power LE 4T 5W40",
        model4012X1L:"7100 4T 10W40 12X1L",
        model20X1L: "H-Tech 100 4T 10W40 20X1L",
        model710010W40: "7100 4T 10W40 12X1L",
        model710010W50: "7100 4T 10W50 12X1L",
        model710015W50: "7100 4T 15W50 12X1L",
        modelHTECH: "H-Tech 100 4T 10W40 20X1L",
        modelSCOOTER: "SCOOTER POWER LE 4T5W40 12X1L",
        linkmodel710010W40: "16705?product=MOTUL+7100+10W-40+4T+VL&sourceLocale=en-SG&id=16705",
        linkmodel710010W50: "16706?product=MOTUL+7100+4T+10W50&sourceLocale=en-SG&id=16706",
        linkmodel710015W50: "16709?product=MOTUL+7100+4T+15W50&sourceLocale=en-SG&id=16709",
        linkmodelHTECH: "37302?product=H-TECH%2B100%2B4T%2B10W30%2B20X1L&sourceLocale=en-SG",
        linkmodelSCOOTER:"58150?product=MOTUL+SCOOTER+POWER+LE+4T+5W-40&sourceLocale=en-SG&id=58150",
        // pageNub:"ข้อที่PH",
        // page:"หน้าPH",
        page1: {
          proName: 'Thank You For Scanning',
          ProCodeName: 'Serial Number:',
          btnText:'Copy Detection Not Available',
          //For authentication please use a compatible phone & download the App(有一段这个，compatible phone高亮，跳转位置和下面按钮一样)
          moreText:'Swipe up for more information.'
        },
        page2: {
          topText:'Product Information',
          btnText:'More Information',
          moreText:'Swipe up for more information.',
          model5012X1L: "High performance bikes, sports bikes, street & road bikes, trails, off road bikes, enduro, trial…fitted with 4 stroke engines, integrated gearbox or not, wet or dry clutch, engines meeting Euro 2 or Euro 3 emission regulation, fitted with exhaust gas after treatment systems : catalytic converters, air injection into exhaust pipe... Recommended for specific DUCATI, KTM, BMW engines requiring SAE 10W-50 viscosity grade oil.",
          model5W40: "Specially formulated for gearboxes with wet clutch using a different oil from engine oil: gearbox case separated from engine crankcase. All Motorbikes, Road, Trails, Cross (2 or 4-stroke engines), Enduro (2 or 4-stroke engines), Mopeds, Scooters, Quads. Suitable when manufacturers require SAE 10W-30 engine oil or SAE 80 gearbox oil.",
          model4012X1L: "High performance bikes, sports bikes, street & road bikes, trails, off road bikes, enduro, trial…fitted with 4 stroke engines, integrated gearbox or not, wet or dry clutch, engines meeting Euro 2 or Euro 3 emission regulation, fitted with exhaust gas after treatment systems : catalytic converters, air injection into exhaust pipe... Suitable for specific SUZUKI, YAMAHA, KAWASAKI engines requiring SAE 10W-40 viscosity grade oil.",
          model20X1L: "100% Synthetic motorcycle lubricant for all 4-stroke motorbike engines requiring 10W40 viscosity grade. Type of use: Road and off road bikes, Trails, 4-stroke Cross/ Enduro bikes, Quads, Scooters, Mopeds.",
        },
        page3: {
          text1:"Useful Tools",
          text2:"Oil Recommendation",
          text3:"Use the VIN number to quickly look up the best oil product for your vehicle.",
          text4:"Find A Dealer"
        },
        page4: {
          topText:'Contact Us',
          middleText:'How May We Help You?',
          emailAct:'CONTACT US'
      },
      verification: {
        titleText: 'Verification Successful',
        infoText: 'Thank you for using a genuine Motul Product.',
        productText: 'Product Name:',
        batchText: 'Batch Number: 1089466',
        btnText: 'View Product Information',
      }
    },
    zh: {
      message: {
        hello: '你好，世界'
      }
    }
  };
  export default  messages